export default {
  'forgot.password.title': 'Forgot password',
  'forgot.password.description':
    'Please enter the registered email address to request a password restore',
  'forgot.password.notification':
    'The password recovery link has been sent to your email.Please check the email and click on the link attached in the mail to start reset the password.',
  'forgot.password.email': 'Email',
  'forgot.password.button.accept': 'Confirm',
  'forgot.password.email.not.exit': 'Email does not exist',
  'forgot.password.email.invalid': 'Email is not a valid email!',

  'forgot.password.code.title': 'Verification',
  'forgot.recoveryCode': 'Enter the confirmation code',
  'forgot.desc': 'Please enter the registered email address to request a password recovery',
  'forgot.text.desc':
    'The password recovery link has been sent to your email.Please check the email and click on the link included in the mail to start reset the password. ',
  'forgot.password.username': 'Username',
  'forgot.required.username': 'Please enter username',
};
